import { ref } from 'vue'

export function useCloudinary() {
  const imageUrl = ref('')
  const imagePublicId = ref('')

  const insertUploadWidgetScript = () => {
    const uploadWidgetScript = document.createElement('script')
    uploadWidgetScript.src = import.meta.env.VITE_CLOUDINARY_SCRIPT
    uploadWidgetScript.async = true
    document.head.appendChild(uploadWidgetScript)
  }

  const openUploadModal = () => {
    if (cloudinary) {
      cloudinary
        .createUploadWidget(
          {
            cloudName: import.meta.env.VITE_CLOUDINARY_NAME,
            uploadPreset: import.meta.env.VITE_CLOUDINARY_UPLOAD_PRESET,
            folder: 'editor',
            sources: ['local', 'url'],
            cropping: false,
            multiple: false,
            maxFiles: 1,
            maxImageFileSize: 5000000,
            maxFileSize: 5000000,
            clientAllowedFormats: ['png', 'jpg', 'jpeg', 'webp'],
          },
          (error, result) => {
            if (!error && result && result.event === 'success') {
              imageUrl.value = result.info.secure_url
              imagePublicId.value = result.info.public_id
            }
          },
        )
        .open()
    }
  }

  return { openUploadModal, insertUploadWidgetScript, imageUrl }
}
